<template>
  <div class="container">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 引用header组件 -->
      <Header class="head"></Header>
      <!-- 中间内容 -->
      <div class="banner-content">
        <!-- 标题 -->
        <div class="banner-first-title">
          关于我们
        </div>
        <!-- 副标题 -->
        <div class="banner-second-title">
          About us
        </div>
        <div class="banner-line"></div>
        <!-- list -->
        <div class="banner-list">
          <div
            class="list-item"
            v-for="(item, index) in bannerList"
            :key="index"
          >
            <div class="banner-item">
              {{ item.name }}
            </div>
            <div class="banner-dot" v-if="item.dot"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 正文区域 -->
    <div class="content">
      <!-- 公司介绍 -->
      <div class="intro">
        <!-- 左侧图片 -->
        <div class="img">
          <img src="../assets/img/aboutus/company.png" alt="" />
        </div>
        <!-- 右侧文字 -->
        <div class="detail">
          <!-- 标题 -->
          <div class="tit">公司介绍</div>
          <!-- 内容 -->
          <div class="text">
            <p v-for="(item, index) in introduce" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
      <!-- 企业文化 -->
      <div class="cultrue">
        <!-- 4等份 -->
        <div
          class="culture-item"
          v-for="(item, index) in cultrueList"
          :key="index"
        >
          <div class="name">{{ item.name }}</div>
          <div class="en">{{ item.en }}</div>
          <div class="icon">
            <i class="el-icon-place"></i>
          </div>
          <div class="sologan">{{ item.sologan }}</div>
        </div>
      </div>
      <!-- 横线 -->
      <div class="line"></div>
      <!-- 商务合作 -->
      <div class="cooperation">
        <!-- 标题 -->
        <div class="title">
          商务合作
        </div>
        <!-- 正文 -->
        <div class="content2">
          <!-- 左侧 -->
          <div class="content2-left">
            <el-form
              :model="agriculturalFeedbackForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="姓名" prop="userName">
                <el-input
                  v-model="agriculturalFeedbackForm.userName"
                  placeholder="请输入您的姓名或称呼"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式" prop="contact">
                <el-input
                  v-model="agriculturalFeedbackForm.contact"
                  placeholder="请输入您的联系方式"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="content">
                <el-input
                  v-model="agriculturalFeedbackForm.content"
                  placeholder="请输入备注信息"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 右侧图片 -->
          <div class="img">
            <img src="../assets/img/aboutus/cooperation.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 地址 -->
      <div class="address">
        <!-- 左侧地图 -->
        <div id="map" class="qqmap"></div>
        <!-- 右侧位置 -->
        <div class="company">
          <div class="first-title">江苏城歌科技有限公司</div>
          <div class="sencond-title">
            <div class="item2">
              <i class="el-icon-document-checked"></i
              ><span>邮箱：support@cityode.com</span>
            </div>
            <div class="item2">
              <i
                class="el-icon-phone-outline
"
              ></i
              ><span>电话：{{ mobile }}</span>
            </div>
            <div class="item2">
              <i class="el-icon-location-information"></i>
              <span>地址：江苏省南京市鼓楼区南铁院金川科技园</span>
            </div>
          </div>
          <!-- 二维码 -->
          <div class="qrcode aboutus">
            <div class="img">
              <img src="../assets/img/home/gongzhong.jpg" alt="" />
            </div>
            <!-- 文案 -->
            <div class="span">关注公众号了解更多</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引用头部组件
import Header from '../components/header.vue'
export default {
  components: {
    Header
  },
  data() {
    return {
      // 标题栏
      tabNameList: [
        {
          name: '首页',
          path: '/',
          slash: true
        },
        {
          name: '关于我们',
          path: '/about',
          slash: true
        },
        {
          name: '智慧农贸',
          path: '/market',
          slash: true
        },
        {
          name: 'AI识别',
          path: '/ai',
          slash: true
        },
        {
          name: '成功案例',
          path: '/case',
          slash: true
        },
        {
          name: '联系我们',
          path: '/contact',
          slash: false
        }
      ],
      // 介绍
      introduce: [
        '江苏城歌科技有限公司致力于智能识别、智慧零售、智慧社区、智慧农贸、无人机智慧农业、智慧政务、AI志愿等多个系统的研发与创新。结合人工智能、大数据、IoT等前沿领域技术完成智慧生活软硬件一体化的创新升级。',
        '服务于社区，帮助邻里间处理闲置物品、协调人力资源，营造和谐邻里关系；',
        '服务于菜市场、商超、餐饮、零售等本地生活服务商家，帮助商家实现智能数字化管理；',
        '服务于农业，推动全球农业的发展革新和进步；',
        '服务于政府，推动智慧政务建设、整合及共享数据信息、促进业务协同；',
        '服务于考生与家长，用大数据算法，AI一键填报高考志愿。'
      ],
      cultrueList: [
        {
          name: '企业秉承',
          en: 'purpose',
          sologan: '以质量求生存，以创新求发展'
        },
        {
          name: '企业文化',
          en: 'culture',
          sologan: '自强不息，厚德载物'
        },
        {
          name: '企业使命',
          en: 'mission',
          sologan: '用智慧推动时代进步'
        },
        {
          name: '企业愿景',
          en: 'vision',
          sologan: '科技创新时代，智慧改变生活'
        }
      ],
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名或称呼', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ]
      },
      agriculturalFeedbackForm: {
        userName: '',
        contact: '',
        content: '', // 备注
        source: 3 // 反馈来源 0-消费者C端 2-官网智慧农贸 3-官网 AI识别
      },
      mobile: this.GLOBAL.mobile,
      bannerList: [
        {
          name: '智慧市场',
          dot: true
        },
        {
          name: '智能称重',
          dot: true
        },
        {
          name: '智慧收银',
          dot: true
        },
        {
          name: '线上商城',
          dot: true
        },
        {
          name: '溯源检测',
          dot: false
        }
      ]
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    // 跳转到其他页面
    goDetail(path) {
      this.$router.push(path)
    },
    // 提交申请
    async submit() {
      // 验证表单是否合理
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        // 验证通过，进行下一步操作
        const { data: res } = await this.$http.post(
          '/api/v1/user/agriculturalFeedback',
          this.agriculturalFeedbackForm
        )
        // console.log(response)
        if (res.code !== 0) {
          return this.$message.error(res.message)
        }
        this.$message.success('提交成功')
        // 清空列表
        this.agriculturalFeedbackForm = {}
        this.agriculturalFeedbackForm.source = 3
        this.backTop()
      })
    },
    // 回到顶部
    backTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    init() {
      let address = ''
      // const that = this
      var center = new qq.maps.LatLng(32.091819, 118.766291)
      var map = new qq.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: 17,
        disableDefaultUI: true
      })
      var marker = new qq.maps.Marker({
        position: center,
        map: map
      })
      var infoWin = new qq.maps.InfoWindow({
        map: map
      })
      var geocoder = new qq.maps.Geocoder({
        complete: function(res) {
          console.log(res)
          address = res.detail.nearPois[0].name
        }
      })
      qq.maps.event.addListener(map, 'click', function(event) {
        this.longitude = event.latLng.getLat()
        this.latitude = event.latLng.getLng()
        console.log(event)
        console.log(marker)
        const lat = new qq.maps.LatLng(this.longitude, this.latitude)
        geocoder.getAddress(lat)
        setTimeout(() => {
          infoWin.open()
          infoWin.setContent(
            '<div style="text-align:center;white-space:nowrap;">' +
              address +
              '</div>'
          )
          infoWin.setPosition(event.latLng)
        }, 200)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  background-color: #f5f5f5;
}
// 头部区域
.header {
  height: 552px;
  width: 100%;
  background-image: url(../assets/img/aboutus/banner2.png);
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  color: #fff;
  font-size: 22px;
  .tab {
    display: flex;
    padding: 40px 50px 0 50px;
    margin: 0 auto;
    width: 1300px;
    .name {
      width: 255px;
      .real-name {
        img {
          margin-top: -10px;
        }
      }
    }
    .title {
      width: 960px;
      display: flex;
      height: 40px;
      line-height: 40px;
      .title-item {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        width: 160px;
        .title-name {
          width: 120px;
          text-align: center;
          margin-left: 20px;
        }
        .title-name:hover {
          font-size: 26px;
        }

        .slash {
          color: #d5d5d5;
        }
      }
    }
    .tel {
      width: 200px;
      display: flex;
      .phone {
        line-height: 60px;
        margin-left: -10px;
        img {
          width: 37px;
          height: 37px;
        }
      }
      .tel-num {
        width: 160px;
        margin: -10px 0 0 10px;
      }
    }
  }
  .banner-content {
    margin: 0 auto;
    color: #ffffff;
    .banner-first-title {
      width: 200px;
      margin: 43px auto;
      font-size: 50px;
    }
    .banner-second-title {
      width: 100px;
      margin: 28px auto;
      font-size: 22px;
    }
    .banner-line {
      width: 128px;
      height: 15px;
      background: #ffffff;
      opacity: 0.6;
      margin: 20px auto;
    }
    .banner-list {
      width: 960px;
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      .list-item {
        width: 220px;
        height: 84px;
        display: flex;
        align-items: center;
        justify-content: center;
        .banner-item {
          width: 100px;
          height: 24px;
          font-size: 24px;
          font-weight: bold;
          line-height: 24px;
        }
        .banner-dot {
          width: 10px;
          height: 10px;
          background: #ffffff;
          border-radius: 50%;
          margin: 0 55px;
        }
      }
    }
  }
  .applybtn {
    position: relative;
    top: 550px;
    margin: 0 auto;
    border: 1px solid #fff;
    text-align: center;
    height: 80px;
    line-height: 80px;
    width: 322px;
    border-radius: 40px;
    font-weight: 500;
    letter-spacing: 5px;
    cursor: default;
    font-size: 28px;
  }
  .applybtn:hover {
    font-size: 30px;
  }
}
.content {
  width: 1298px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  top: -100px;
  padding: 30px;
  .intro {
    display: flex;
    margin-top: 50px;
    height: 500px;
    align-items: center;
    justify-content: center;
    .detail {
      margin-left: 27px;
      .tit {
        color: #333;
        font-size: 30px;
        font-weight: 700;
      }
      .text {
        margin-top: 30px;
        color: #999;
        font-size: 18px;
      }
    }
  }
  // 企业文化
  .cultrue {
    margin-top: 50px;
    width: 1298px;
    height: 500px;
    // background-color: pink;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .culture-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #999;
      .name {
        color: #333;
        font-size: 22px;
      }
      .en {
        margin-top: 10px;
        font-size: 16px;
      }
      .icon {
        margin-top: 30px;
      }
      .sologan {
        margin-top: 30px;
        font-size: 18px;
      }
    }

    .culture-item:hover {
      width: 250px;
      height: 280px;
      box-shadow: 0px 0px 29px 1px rgba(170, 170, 170, 0.1);
      border-radius: 5px;
    }
  }
  .line {
    position: relative;
    top: -233px;
    height: 2px;
    border-bottom: 1px solid #e5e5e5;
  }
  // 合作
  .cooperation {
    margin-top: 50px;

    .title {
      color: #333;
      font-size: 30px;
    }
    .content2 {
      display: flex;
      justify-content: space-around;
      margin-top: 80px;
      .content2-left {
        margin: auto auto;
        .input {
          width: 300px;
        }
        .el-button {
          width: 300px;
        }
      }
    }
  }
  .address {
    display: flex;
    margin-top: 100px;
    .qqmap {
      width: 770px;
      height: 540px;
    }
    .company {
      width: 400px;
      margin-left: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .first-title {
        font-size: 30px;
        cursor: pointer;
      }
      .sencond-title {
        margin-top: 40px;
        font-size: 16px;
        .item2 {
          margin: 20px 0;
          color: #666;
          text-align: start;
          span {
            margin-left: 10px;
          }
        }
      }
      .qrcode {
        margin-top: 100px;
        img {
          width: 132px;
          height: 132px;
        }
        .span {
          font-size: 14px;
          margin-top: 22px;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
